export class BuildParameters {
    buildLabel: string;
}